import React from 'react';
import PropTypes from 'prop-types';

import './Records.css';
import Spinner from '../common/Spinner/Spinner';
import Record from '../Record/Record';

const Records = ({
	records,
	handleStartUpload,
	handlePauseUpload,
	setDetailsForDeleteRecordModal,
	areRecordsLoading,
	focusedPrimaryId,
	openDeleteAllRecordsModal,
}) => {
	const hasRecords = records && records.length > 0;

	return (
		<div className='records-wrapper'>
			<div className="premium-header">
				<div className="analytics-title">
					<i className="material-icons">video_library</i>
					<span>RECORDS</span>
				</div>
			</div>

			<div className='records-body scrollbar-hidden'>
				{areRecordsLoading ? (
					<div className="records-control-spinner">
						<Spinner />
					</div>
				) : hasRecords ? (
					records.map(record => (
						<Record
							key={record.name}
							record={record}
							uniqueKey={record.name}
							handlePauseUpload={handlePauseUpload}
							handleStartUpload={handleStartUpload}
							setDetailsForDeleteRecordModal={setDetailsForDeleteRecordModal}
						/>
					))
				) : (
					<div className="empty-records-state">
						<i className="material-icons">video_library</i>
						<span>No Records Found</span>
					</div>
				)}
			</div>

			<div className="records-footer">
				<button
					className="delete-all-btn"
					onClick={openDeleteAllRecordsModal}
					disabled={!hasRecords || areRecordsLoading}
				>
					<i className="material-icons">delete_forever</i>
					<span>DELETE ALL</span>
				</button>
			</div>
		</div>
	);
};

Records.propTypes = {
	records: PropTypes.array.isRequired,
	areRecordsLoading: PropTypes.bool.isRequired,
	openDeleteAllRecordsModal: PropTypes.func,
};

export default Records;
